import * as React from 'react';
import style from './SearchResults.scss';
import { IResult, Result } from './Result';
import { Button } from '../../../Layout/Button';
import { usePagination } from '../../../../customHooks/usePagination';

const AMOUNT_PER_PAGE = 20;
export const SearchResults = ({
  searchResults,
  onSearchResultClick,
  relatedSitesMap,
}: {
  searchResults: IResult[];
  onSearchResultClick: (chosenArticle?: string) => () => void;
  relatedSitesMap: Map<string, string>;
}) => {
  const [highlightedIndex, setHighlightedIndex] = React.useState(-1);
  const { data: paginatedResults, nextPage, hasMoreDataToLoad } = usePagination(
    {
      data: searchResults,
      entriesPerPage: AMOUNT_PER_PAGE,
    },
  );

  React.useEffect(() => {
    window.addEventListener('keyup', onKeyUpHandler);
    return () => window.removeEventListener('keyup', onKeyUpHandler);
  }, [onKeyUpHandler]);

  const getActiveResult = () =>
    document.querySelector('[data-highlighted="true"]');

  React.useEffect(() => {
    const activeSearchResult = getActiveResult();
    activeSearchResult &&
      activeSearchResult.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
  }, [highlightedIndex]);

  return (
    <ul className={style.searchResults} data-hook="search-results-list">
      {paginatedResults.map((searchResult, i) => (
        <Result
          key={searchResult.id}
          onSearchResultClick={onSearchResultClick}
          isHighlighted={i === highlightedIndex}
          searchResult={searchResult}
          relatedSitesMap={relatedSitesMap}
        />
      ))}
      {hasMoreDataToLoad() && (
        <Button
          className={style.showMoreResultsBtn}
          skin="secondary"
          onClick={() => {
            nextPage();
            setHighlightedIndex(paginatedResults.length);
          }}
        >
          Show More Results
        </Button>
      )}
    </ul>
  );

  function onKeyUpHandler(e) {
    switch (e.code) {
      case 'ArrowDown':
        if (highlightedIndex < paginatedResults.length - 1) {
          setHighlightedIndex((prev) => prev + 1);
        }
        break;
      case 'ArrowUp':
        if (highlightedIndex > 0) {
          setHighlightedIndex((prev) => prev - 1);
        }
        break;
      case 'Enter':
        if (highlightedIndex === -1) {
          return;
        }
        const activeSearchResult = getActiveResult();
        const activeSearchResultAnchor =
          activeSearchResult && activeSearchResult.querySelector('a');
        activeSearchResultAnchor && activeSearchResultAnchor.click();
        break;

      default:
        break;
    }
  }
};
